<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

const { width, height } = useWindowSize()


const displayVariant = computed(() => {
  if (!width.value || !height.value) {
    return 'await'
  }
  return (width.value < 1024 || height.value < 560) ? 'block' : 'unblock'
})

</script>

<template>
  <slot :display="displayVariant">
    <div
      :class="$style.core"
    >
      <div :class="$style.container">
        <NuxtImg
          :class="$style.icon"
          src="/image/resolution.svg"
          alt=""
        />
        <div class="title-1-medium">
          {{ $t('screen_blocked_title') }}
        </div>
        <div class="text-secondary body-1-regular">
          {{ $t('screen_blocked_content') }}
        </div>
      </div>
    </div>
  </slot>
</template>

<style lang="scss" module>
  .core {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--surface-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .container {
    max-width: 684rem;
    padding: 24rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12rem;
  }

  .icon {
    margin-bottom: 4rem;
    display: block;
    margin-inline: auto;
  }
</style>
